import { Component, Input } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { Recipient } from '../../../interfaces/recipient';
import { Donor } from '../../../interfaces/donor';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipantService } from '../../../services/participant.service';
import { ParticipantHistoryBoxComponent } from '../participant-history-box/participant-history-box.component';
import { PairService } from '../../../services/pair.service';
import { Pair } from '../../../interfaces/pair';
import { TimelineHistory } from '../../../interfaces/timeline';
import { TimelineService } from '../../../services/timeline.service';
import { ParticipantBoxComponent } from '../../participant/participant-box/participant-box.component';
import { PagetoolbarComponent } from '../../pagetoolbar/pagetoolbar.component';

@Component({
    selector: 'app-pair-history',
    imports: [MatIconModule, CommonModule, ParticipantHistoryBoxComponent, ParticipantBoxComponent, PagetoolbarComponent],
    templateUrl: './pair-history.component.html',
    styleUrl: './pair-history.component.scss'
})
export class PairHistoryComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private router: Router,
    private pairService: PairService,
    private timelineService: TimelineService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // Register your SVG icons here
    this.matIconRegistry.addSvgIcon('human-male', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-male.svg'));

    this.matIconRegistry.addSvgIcon('human-female', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-female.svg'));
  }

  pairdId: string | null = null;
  pair?: Pair;
  timelineHistoryPair?: TimelineHistory[];

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.pairdId = params.get('id'); // Assign the 'id' parameter to the variable
    });
    if (this.pairdId)
      this.pairService.getPair(this.pairdId).subscribe((result) => {
        this.pair = result;
        if (this.pair) {
          this.timelineService.getHistory(this.pair.id).subscribe((result) => {
            this.timelineHistoryPair = result;
          });
        }
      });
  }
}
